// 业务
export const STORAGE_USER_INFO = 'aiUserInfo'; // 用户信息
export const COOKIE_USER_TOKEN = 'token'; // 用户标识
export const SESSION_AI_CHAT_INPUT = 'aiChatInputValue'; // 输入内容暂存
export const SESSION_AI_CHAT_AUTO_SUBMIT = 'aiChatAutoSubmit'; // 输入内容立即提交
export const DEFAULT_MODEL_ID = 1; // 默认模型ID
